class LevelScene extends Phaser.Scene
{
	constructor()
	{
		super({ key: "levelScene" });

		this.player = null;
		this.platform = null;
		this.ufo = null;
		this.beam = null;
		this.particles = null;
		this.pemitter = null;

		this.mode = 1;
		this.nextLevel = 1;
		this.totalLevels = 30;
		this.finishedLevel = -1;
	}

	init(data)
	{
		this.mode = 1;
		this.nextLevel = 1;
		this.finishedLevel = -1;

		if (data && data.state)
		{
			if (data.state == "quit")
			{
				this.mode = 2;
				this.nextLevel = data.level;
			}
			else if (data.state == "win")
			{
				this.mode = 3;
				this.finishedLevel = data.level;
				this.nextLevel = Math.min(data.level + 1, this.totalLevels);
			}
		}
	}

	preload()
	{
		this.model = this.sys.game.globals.model;

		this.load.image("sky", require("../assets/sky.jpg"));
		this.load.image("moon", require("../assets/moon.jpg"));
		this.load.image("particle", require("../assets/bomb.png"));
		this.load.image("level-main", require("../assets/level-main.jpg"));
		this.load.image("photo1", require("../assets/level-photo1.jpg"));
		this.load.image("photo2", require("../assets/level-photo2.jpg"));

		this.load.spritesheet("platforms", require("../assets/platforms.png"), { frameWidth: 50, frameHeight: 40 });
		this.load.spritesheet("player", require("../assets/player-sheet.png"), { frameWidth: 50, frameHeight: 40 });
		this.load.spritesheet("things", require("../assets/things.png"), { frameWidth: 50, frameHeight: 40 });

		this.load.audio("music", require("../assets/sounds/ROAR_Entertainment_Martians.mp3"));
		this.load.audio("sound-click", require("../assets/sounds/click.mp3"));
	}

	create()
	{
		var self = this;

		if (this.mode == 1)
		{
			// on start, read settings
			this.model.readConfig();
		}

		var maxLevel = 1;
		if (this.nextLevel > maxLevel)
		{
			maxLevel = this.nextLevel;
		}

		//localStorage.removeItem("time");
		// localStorage: time=xor max finished level, sound=1|0, music=1|0
		var lsFinishedLevel = parseInt(this.model.getPersistentData("time") || 0);

		if (lsFinishedLevel != 0)
		{
			lsFinishedLevel = lsFinishedLevel ^ 174;
			if (lsFinishedLevel < 0 || lsFinishedLevel > this.totalLevels)
			{
				lsFinishedLevel = 0;
			}
			this.model.sendStat("level", lsFinishedLevel);

			maxLevel = Math.min(lsFinishedLevel + 1, this.totalLevels);
		}

		if (this.mode == 3)
		{
			this.model.sendStat("level", Math.max(this.finishedLevel, lsFinishedLevel));

			if (this.finishedLevel > lsFinishedLevel)
			{
				this.model.setPersistentData("time", this.finishedLevel ^ 174);
			}

			if (this.nextLevel > maxLevel)
			{
				maxLevel = this.nextLevel;
			}
		}

		this.anims.create({ key: "player-start", frames: [{ key: "player", frame: 0 }], frameRate: 20 });
		this.anims.create({ key: "player-hover", frames: [{ key: "player", frame: 29 }], frameRate: 20 });
		this.anims.create({ key: "ufo-hover", frames: [{ key: "things", frame: 2 }], frameRate: 20 });
		this.anims.create({ key: "platform-exit", frames: [{ key: "platforms", frame: 8 }], frameRate: 20, repeat: 0 });
		this.anims.create({ key: "button-0", frames: [{ key: "things", frame: 3 }], frameRate: 20 });
		this.anims.create({ key: "button-1", frames: [{ key: "things", frame: 4 }], frameRate: 20 });
		
		// left 50 column
		// a) game start or quit: player is abducted: Earth background, blue light column, player moving up, UFO at top
		// b) level select after win: player moves to next level: player moving up, platform moving up
		if (this.mode == 3)
		{
			this.add.image(0, 16.6 * (this.nextLevel - 1) - 500, "sky").setOrigin(0, 0); // y depends on finished level

			this.particles = this.add.particles("particle");
			this.pemitter = this.particles.createEmitter({
				speed: 20,
				scale: { start: 1, end: 0 },
				blendMode: 'ADD',
				angle: { min: 0, max: 180 },
				x: 25,
				y: 520,
				tint: 0xDD3300
			});
	
			this.platform = this.add.sprite(25, 538, "platforms");
			this.platform.anims.play("platform-exit");

			this.player = this.add.sprite(25, 520, "player");
			this.player.anims.play("player-start");
		}
		else
		{
			this.add.image(0, 0, "moon").setOrigin(0, 0);

			this.beam = this.add.graphics();
			this.beam.fillStyle(0x25a1ce, 0.5);
			this.beam.fillRect(10, 0, 30, 650);
			this.beam.fillStyle(0x25a1ce, 0.5);
			this.beam.fillRect(15, 0, 20, 650);
			this.beam.x = 0;
			this.beam.y = 100;

			this.ufo = this.add.sprite(25, 100, "things");
			this.ufo.anims.play("ufo-hover");

			this.player = this.add.sprite(25, 520, "player");
			this.player.anims.play("player-hover");

			this.particles = this.add.particles("particle");
			this.pemitter = this.particles.createEmitter({
				speed: 250,
				scale: { start: 1, end: 0 },
				blendMode: 'ADD',
				angle: { min: 265, max: 275 },
				x: 25,
				y: 520,
				tint: 0x25a1ce
			});
		}

		this.add.image(50, 0, "level-main").setOrigin(0, 0);

		if (this.finishedLevel < this.totalLevels && lsFinishedLevel < this.totalLevels)
		{
			this.add.image(50, 0, "photo1").setOrigin(0, 0);
		}
		else
		{
			this.add.image(50, 0, "photo2").setOrigin(0, 0);
		}

		for (var i = 0; i < this.totalLevels; i++)
		{
			let x = 115 + (i % 6) * 57;
			let y = 220 + Math.floor(i / 6) * 40;
			let level = i + 1;
			let button = this.add.sprite(x, y + 8, "things");
			button.anims.play("button-" + (level <= maxLevel ? "1" : "0"));

			this.make.text({
				x: x,
				y: y,
				text: level,
				style: this.getTextStyleConfig(18, level <= maxLevel ? "#ffffff" : "#a0a0a0", "center")
			}).setOrigin(0.5, 0);

			if (level <= maxLevel)
			{
				button.setInteractive({ useHandCursor: true });
				button.on("pointerup", function(p, x, y, event) { event.stopPropagation(); self.model.playSound(self, "sound-click"); self.scene.start("gameScene", { level: level }); });
			}
			else
			{
				button.alpha = 0.6;
			}
		}

		var continueBg = this.add.graphics();
		continueBg.fillStyle(0x222222, .75);
		continueBg.fillRect(125, 440, 275, 50);
		continueBg.setInteractive({ useHandCursor: true, hitArea: new Phaser.Geom.Rectangle(125, 440, 275, 50), hitAreaCallback: Phaser.Geom.Rectangle.Contains });
		continueBg.on("pointerup", function(p, x, y, event) { event.stopPropagation(); self.model.playSound(self, "sound-click"); self.scene.start("gameScene", { level: self.nextLevel }); });

		this.make.text({
			x: 260,
			y: 443,
			text: this.mode == 1 ? "START" : (this.mode == 2 ? "RETRY" : "CONTINUE"),
			style: this.getTextStyleConfig(32, "#ffffff", "center")
		}).setOrigin(0.5, 0);
		this.make.text({
			x: 260,
			y: 472,
			text: "(press SPACE or ENTER)",
			style: this.getTextStyleConfig(12, "#ffffff", "center")
		}).setOrigin(0.5, 0);

		this.input.keyboard.on("keydown-SPACE", this.keyPress);
		this.input.keyboard.on("keydown-ENTER", this.keyPress);
		this.input.keyboard.on("keydown-M", this.keyPress);
		this.input.keyboard.on("keydown-N", this.keyPress);

		if (!this.model.music)
		{
			this.model.playMusic(this, "music");
		}
	}

	getTextStyleConfig(size, color, align)
	{
		return { fontFamily: "Aldrich, monospace, Constantia, Arial, sans-serif", fontSize: size + "px", color: color, align: align };
	}

	keyPress(keyEvent)
	{
		var self = this.scene;
		if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.SPACE || keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.ENTER)
		{
			self.model.playSound(self, "sound-click");
			self.scene.start("gameScene", { level: self.nextLevel });
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.M)
		{
			self.model.volume = 1 - self.model.volume;
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.N)
		{
			self.model.soundVolume = 1;
			self.model.musicVolume = 0;
		}
	}

	update(time, delta)
	{
		//var y = 520 - time - this.startTime / 100;

		if (this.mode == 3)
		{
			if (this.player.visible)
			{
				if (this.player.y > -50)
				{
					var dy = delta * -0.1;
					this.player.y += dy;
					this.platform.y = this.player.y + 15;
					this.pemitter.setPosition(25, this.player.y + 15 + 15);
				}
				else
				{
					this.player.visible = false;
				}
			}
		}
		else
		{
			if (this.player.visible)
			{
				if (this.player.y > -50)
				{
					var dy = delta * -0.1;
					this.player.y += dy;
					if (this.player.y < 250)
					{
						this.ufo.y = (this.player.y - 250) / 2 + 100;
						this.beam.y = this.ufo.y;

						if (this.player.y < 0)
						{
							var dy = 1 - (-this.player.y * delta * 0.002);
							if (dy < 0) dy = 0;
							this.beam.alpha = dy;
							this.pemitter.stop();
							//this.pemitter.scaleY = dy * 250;
						}
					}
				}
				else
				{
					this.player.visible = false;
					this.beam.destroy();
					this.pemitter.stop();
					//this.particles.destroy();
					// TODO player swush sfx
				}
			}
		}
	}

	end()
	{
	}
}

export default LevelScene;